import { connect } from 'react-redux';
import React, { useEffect, useMemo, useState } from 'react';
import Style from './style';
import PDCCFrame from '../pDCCFrameNew';
import { actions } from '../../../../../../../store/reducers/authentication';
import { useNodes } from '../../../../../../../helpers/ToggleableNodesProject/hook';
import { RenderToggelableFlow } from '../../../../../../../helpers/ToggleableNodesProject';
import ComponentWithFocus from '../../../../../../Analysis/components/component-with-focus';
import DashboardPopover from '../../../../../../../components/dashboards/components/Popover';

const SourceOfInformation = ({
  t = (s) => s,
  data = null,
  projectDatastakeId = null,
  user = null,
  clients = null,
  changeSelectedProject,
  changeSourceId,
}) => {
  const [frameActions, setFrameActions] = useState(null);
  const [activeNode, setActiveNode] = useState(null);
  const [toggled, setToggled] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState(false);

  const _clients = useMemo(() => {
    if (clients && clients.ownData) {
      return { ownData: { ...clients.ownData, id: 'fakeOwnData' } };
    }
    return null;
  }, [clients]);

  const {
    elements,
    onConnect,
    onElementsRemove,
    onLoad,
    initElements,
  } = useNodes({
    items: data,
    type: 'RL',
    setActiveNode,
    t,
    user,
    showToggle: false,
    subjectType: '_source',
    changeSourceId,
    changeSelectedProject,
    userModule: "pme",
    projectDatastakeId,
    setPopoverVisible,
  });
  const {
    elements: elementsClients,
    initElements: initElementsClients
  } = useNodes({
    items: _clients,
    type: 'LR',
    setActiveNode,
    setPopoverVisible,
    subjectType: '_client',
    setChildrensCount: () => { },
    t,
    user,
    showToggle: false,
    changeSourceId,
    changeSelectedProject,
    userModule: "pme",
    projectDatastakeId,
  });

  const allElements = useMemo(() => {
    if (clients) {
      return [...elements, ...elementsClients];
    }
    return elements;
  }, [elements, elementsClients, clients]);

  const _initElements = useMemo(() => {
    if (clients && initElements && initElementsClients) {
      return [...initElements, ...initElementsClients];
    }
    return initElements;
  }, [initElements, initElementsClients, clients]);

  useEffect(() => {
    if (frameActions) {
      if (data) {
        frameActions.loading(false);
      } else {
        frameActions.loading(true);
      }
    }
  }, [frameActions, data]);

  const _value = allElements.filter((e) =>
    e.className === 'node' && !e.isLir
  ).length - 2;

  const [closed, setClosed] = useState(false);
  const actions = useMemo(() => ({
    closed,
    setClosed,
    unFocus: () => { },
  }), [closed]);

  return (
    <Style id="3a">
      <PDCCFrame
        className="project-frame"
        legend={[]}
        mB
        title={t('Data Chain of Custody')}
        activeNode={activeNode}
        onInit={(actions) => setFrameActions(actions)}
        type="SOURCES"
        t={t}
        projectDatastakeId={projectDatastakeId}
        showWhenNoData={false}
        value={_value}
        toggled={toggled}
        setToggled={setToggled}
        tooltip={(
          <DashboardPopover
            title={t('Data Chain of Custody')}
            body={t('This application allows you to monitor where information comes from, and where it is shared.')}
          />
        )}
      >
        <ComponentWithFocus actions={actions} show={popoverVisible}>
          <RenderToggelableFlow
            panOnScroll
            elements={allElements}
            onElementsRemove={onElementsRemove}
            onConnect={onConnect}
            onLoad={onLoad}
            initElements={_initElements}
            setActiveNode={setActiveNode}
            setToggled={setToggled}
          />
        </ComponentWithFocus>
      </PDCCFrame>
    </Style>
  );
};

export default connect(null, { ...actions })(SourceOfInformation);
